import { useEffect, useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Field, FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';

// R3: AlertDialog de ui/ (c-alert-dialog-5) — mismo criterio que
// ConfirmarDesactivacionDialog de pages/administracion.tsx: un diálogo de
// confirmación parametrizado en título/texto/label, reusado acá para borrar
// RDT, borrar comentario, archivar/desarchivar (con nota) y descartar una
// edición sin guardar. Misma API pública (`ConfirmDialogState`, `Props`) para
// sus consumidores (actividad.tsx, pages/obra-detalle.tsx).
export interface ConfirmDialogState {
  title: string;
  description: string;
  confirmLabel: string;
  destructive?: boolean;
  /** Campo de nota libre opcional (decisión #4 v0.9.0, ej. motivo del
   *  archivado) — si está, el valor viaja a onConfirm; null si quedó vacío. */
  nota?: { label: string; placeholder?: string };
  onConfirm: (nota: string | null) => void;
}

interface Props {
  state: ConfirmDialogState | null;
  onOpenChange: (open: boolean) => void;
}

export function ConfirmDialog({ state, onOpenChange }: Props) {
  const [nota, setNota] = useState('');
  // Cada apertura arranca con el campo limpio (el state es un objeto nuevo
  // por invocación — no se reusa entre confirmaciones).
  useEffect(() => setNota(''), [state]);
  return (
    <AlertDialog open={state !== null} onOpenChange={next => !next && onOpenChange(false)}>
      <AlertDialogContent size="sm">
        <AlertDialogHeader>
          <AlertDialogTitle>{state?.title}</AlertDialogTitle>
          <AlertDialogDescription>{state?.description}</AlertDialogDescription>
        </AlertDialogHeader>
        {state?.nota && (
          <Field>
            <FieldLabel htmlFor="confirm-dialog-nota">{state.nota.label}</FieldLabel>
            <Input
              id="confirm-dialog-nota"
              value={nota}
              maxLength={255}
              placeholder={state.nota.placeholder}
              onChange={e => setNota(e.target.value)}
            />
          </Field>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            variant={state?.destructive ? 'destructive' : 'default'}
            onClick={() => {
              state?.onConfirm(state.nota ? nota.trim() || null : null);
              onOpenChange(false);
            }}
          >
            {state?.confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
